export interface FaqItem {
  pregunta: string;
  resumen: string;
  respuesta: string;
}

export const faqItems: FaqItem[] = [
  {
    pregunta: '¿Necesito saber cocinar para usar esta guía?',
    resumen: 'No.',
    respuesta:
      'Instrucciones paso a paso, ingredientes simples y tiempos claros. Hasta 40 recetas te llevan menos de 10 minutos.'
  },
  {
    pregunta: '¿Los ingredientes son fáciles de conseguir en España?',
    resumen: 'Sí.',
    respuesta: 'Todo se compra en el supermercado español, sin nada raro, caro ni imposible de encontrar.'
  },
  {
    pregunta: '¿Cuándo recibo acceso después de comprar?',
    resumen: 'Inmediato.',
    respuesta:
      'En menos de 2 minutos te llega un email con el link de descarga en PDF, listo para usar en el móvil, la tablet o la computadora.'
  },
  {
    pregunta: '¿Hay garantía si no quedo conforme?',
    resumen: '7 días.',
    respuesta:
      'Si tienes problemas para acceder al material, falta alguno de los contenidos anunciados o lo recibido no corresponde con la oferta mostrada en esta página, escríbenos a manualeslistos@gmail.com y lo resolveremos.'
  },
  {
    pregunta: '¿En cuánto tiempo noto cambios?',
    resumen: '7 días.',
    respuesta:
      'Los primeros cambios llegan rápido. La mayoría nota una diferencia clara en 2-3 semanas, y a las 12 semanas la transformación es real, tanto en datos como en cómo te sentís.'
  },
  {
    pregunta: '¿Y si tengo intolerancias o alergias?',
    resumen: 'Sí, funciona igual.',
    respuesta:
      'El Bono 3 (La Biblia de los Reemplazos) trae alternativas sin gluten, sin lácteos, sin huevo y recetas específicas para colon irritable.'
  },
  {
    pregunta: '¿Necesito comprar suplementos o productos especiales?',
    resumen: 'No.',
    respuesta: 'Todo son alimentos reales del supermercado. Sin batidos especiales, sin polvos mágicos.'
  },
  {
    pregunta: '¿Cómo descargo el material después de comprar?',
    resumen: 'Muy fácil.',
    respuesta: 'Te llega un link de descarga en PDF directo a tu email dentro de los primeros 2 minutos después de la compra.'
  }
];
